
import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  created () {
  },
  mounted () {},
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Catalogs')
    },
    Tabs () {
      return [
        { Name: this.Translate('Catalogs'), Link: 'Edit', Access: this.Access('Catalogue_Read') },
        { Name: this.Translate('Sending History'), Link: 'History', Access: this.Access('Catalogue_Read') },
        { Name: this.Translate('Settings'), Link: 'Settings', Access: this.Access('Catalogue_Edit') }
      ] as Array<CookiesTabs>
    }
  },
  methods: {},
  watch: {}
})
